import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  listHeader: ({
    isListScrolled,
    tableItemGridTemplate,
  }: {
    isListScrolled?: boolean;
    tableItemGridTemplate?: string;
  }) => ({
    display: 'grid',
    gridTemplateColumns: tableItemGridTemplate,
    padding: theme.spacing(1, 0, 1, 6),
    transition: 'background-color 0.3s ease-in-out',
    backgroundColor: isListScrolled ? theme.palette.common.white : 'transparent',
  }),
  headerItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& > span': {
      color: theme.palette.neutral.dark,
      fontSize: '0.625rem',
      fontWeight: 700,
    },
  },
  sortable: {
    cursor: 'pointer',

    '& > svg': {
      transition: 'opacity 0.2s ease-in-out',
      opacity: 0,
    },

    '&:hover > svg': {
      opacity: 1,
    },
  },
  active: {
    color: theme.palette.text.primary,
    '& > span': {
      color: theme.palette.text.primary,
    },

    '& > svg': {
      opacity: 1,
    },
  },
}));

export default useStyles;
